import i18n from "@/plugins/i18n";

// Mixins to Determine devices are online/offline
export const devicesMixins = {
  computed: {
    devicesState() {
      return this.$store.state.devices.devicesState;
    },
    halo_data_links_availability() {
      return this.$store.state.devices.halo_data_links_availability;
    },
    halo_data_links_info() {
      return this.$store.state.devices.halo_data_links_info;
    },
    applicationRules() {
      return this.$store.state.dataPath.applicationRules;
    },
    devices() {
      return this.$store.state.devices.devices.map(device => {
        this.processApplicationRules(device);
        this.processDeviceState(device);
        return device;
      });
    },
    onlineDevices() {
      return this.devices.filter(
        device => device.isOnline && device.is_activated
      );
    },
    status() {
      let total = this.devices.length;
      let online = this.onlineDevices.length;
      let offline = total - online;
      let upLinks = 0;
      let downLinks = 0;
      let totalLinks = 0;

      this.onlineDevices.forEach(device => {
        upLinks += device.linksOnline;
        downLinks += device.linksOffline;
        totalLinks += device.linksTotal;
      });

      return { online, offline, total, upLinks, downLinks, totalLinks };
    },
    totalUpload() {
      let upload = getTotalNICsSpeed(this.onlineDevices, "upload");
      return parseNICsSpeed(upload);
    },
    totalDownload() {
      let download = getTotalNICsSpeed(this.onlineDevices, "download");
      return parseNICsSpeed(download);
    }
  },
  methods: {
    processDeviceState(device) {
      const dataLinksAvailability = this.halo_data_links_availability.find(
        item => item.device_id === device.id
      );
      device.availability = "-";
      device.links = "-";
      device.state = getDeviceState(this.devicesState, device.id);
      device.isOnline = device.state && device.state === 1;
      parseDeviceAvailability(device);

      if (dataLinksAvailability && device.is_activated)
        parseDeviceLinksAvailability(device, dataLinksAvailability);

      return device;
    },
    processApplicationRules(device) {
      let applicationRules = this.applicationRules.filter(item => {
        return device.application_rules.indexOf(item.id) !== -1;
      });
      device.membership = applicationRules.map(item => item.name).join(" ");
    }
  }
};

// Devices Utility fucntions

function getDeviceState(devicesState, deviceId) {
  const device_state = devicesState.find(
    deviceState => deviceState.device_id === deviceId
  );
  if (device_state) return device_state.device_state;

  return device_state;
}

function parseDeviceLinksAvailability(device, dataLinksAvailability) {
  device.main_app_status = device.isOnline
    ? dataLinksAvailability.main_app_status
    : null;
  parseDeviceNICsInfo(device, dataLinksAvailability.nics_info);
  parseDeviceLocation(device, dataLinksAvailability.latest_location);
}

function parseNICsSpeed(nicsSpeed) {
  let sum = nicsSpeed / 1024;
  if (sum > 0 && sum < 0.1) {
    return 0.1;
  }
  return parseFloat(sum.toFixed(1));
}

function getNICSpeed(data, type = "wifi", speedType = "upload") {
  return data[type].reduce((total, item) => {
    if (item.net_stats) {
      return total + (item.net_stats[speedType].avg || 0);
    }
    return total;
  }, 0);
}

function getTotalNICsSpeed(onlineDevices, speedType = "upload") {
  let speed = 0;
  onlineDevices.forEach(item => {
    if (item.halo_data_links_info) {
      let data = item.halo_data_links_info.nics_info;
      speed += getNICSpeed(data, "wifi", speedType);
      speed += getNICSpeed(data, "eth", speedType);
      speed += getNICSpeed(data, "cellular", speedType);

      if ("vlan" in data) {
        speed += getNICSpeed(data, "vlan", speedType);
      }
      if ("vpn" in data) {
        speed += getNICSpeed(data, "vpn", speedType);
      }
    }
  });

  return speed;
}

function parseDeviceLocation(device, location) {
  device.latest_location = location || null;
  if (device.latest_location) {
    if (device.latest_location.accuracy === 0) {
      if (
        device.latest_location.coordinate.reduce(
          (total, item) => (total += item),
          0
        ) === 0
      ) {
        device.latest_location.status = 0;
      } else {
        device.latest_location.status = 1;
      }
    } else {
      if (device.isOnline) device.latest_location.status = 2;
      else device.latest_location.status = 1;
    }
  }
}

function parseDeviceNICsInfo(device, nicsInfo) {
  let onlineLinks =
    nicsInfo.cellular.online + nicsInfo.eth.online + nicsInfo.wifi.online;
  let offlineLinks =
    nicsInfo.cellular.offline + nicsInfo.eth.offline + nicsInfo.wifi.offline;
  let totalLinks = onlineLinks + offlineLinks;

  if (device.isOnline) {
    device.linksOnline = onlineLinks;
    device.linksOffline = offlineLinks;
    device.linksTotal = totalLinks;
    device.links = device.linksOnline + "/" + device.linksTotal;

    return;
  }

  device.links = `0/${totalLinks}`;
}

function parseDeviceAvailability(device) {
  if (!device.is_activated && device.state !== undefined) {
    device.availability = i18n.t("modules.devices.nonActivated");
  } else if (device.state === 1) {
    device.availability = i18n.t("modules.devices.online");
  } else if (device.state === 0) {
    device.availability = i18n.t("modules.devices.offline");
  }
}
